<template>
  <div>
    <div class="fixed px-2 pb-2 bottom-0 w-full left-0">
      <span
        v-if="$route.name != link.name"
        v-for="(link, i) in nav"
        v-bind:key="i"
      >
        <router-link
          class="leading-none inline-block mx-auto rounded-full mr-2 p-3 bg-push-gray shadow-lg hover:bg-push-orange focus:bg-push-orange"
          :to="{ name: link.name }"
        >
          <i :class="'fas ' + link.icon + ' text-xl text-white'"></i>
        </router-link>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileFooter",
  data() {
    return {
      nav: [
        { name: "add-poll", icon: "fa-plus" },
        { name: "home", icon: "fa-list-alt" }
        //{ name: 'profile', icon: 'fa-user-alt' }
      ]
    };
  }
};
</script>

<style></style>
